import { useEffect, useState } from "react";
import { BellRing, Phone, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const hoursAgo = (iso) => Math.floor((Date.now() - new Date(iso).getTime()) / 3600000);
const waiting = (iso) => {
  const h = hoursAgo(iso);
  return h >= 48 ? `${Math.floor(h / 24)} days` : `${h} hrs`;
};

export const FollowUps = ({ onChange }) => {
  const [rows, setRows] = useState([]);
  const [names, setNames] = useState({});
  useEffect(() => {
    api.get("/admin/followups").then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
    api.get("/admin/team").then((r) => setNames(Object.fromEntries((Array.isArray(r.data) ? r.data : []).map((m) => [m.id, m.name])))).catch(() => {});
  }, []);

  const markContacted = async (id) => {
    try {
      await api.patch(`/admin/leads/${id}`, { status: "contacted" });
      setRows((p) => p.filter((r) => r.id !== id));
      onChange?.();
      toast.success("Marked as contacted");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className={`bento ${rows.length ? "border-amber-400/40" : ""}`} data-testid="admin-followups">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 font-display text-lg font-semibold">
          <BellRing size={18} className={rows.length ? "text-amber-300" : "text-slate-400"} />
          Today's follow-ups
          <span className="rounded-full bg-amber-400/15 px-2.5 py-0.5 font-mono text-xs text-amber-300" data-testid="followups-count">{rows.length}</span>
        </p>
        <p className="text-xs text-slate-400">Leads still marked “new” more than 24 hours after applying</p>
      </div>
      {rows.length ? (
        <ul className="mt-4 divide-y divide-white/5">
          {rows.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center gap-x-4 gap-y-2 py-3 text-sm" data-testid={`followup-${r.ref}`}>
              <span className="font-mono text-xs text-orange-300">{r.ref}</span>
              <span className="min-w-[140px] flex-1 font-medium">{r.name}<span className="ml-2 text-xs text-slate-400">{r.state}</span></span>
              <span className="text-xs text-amber-300">waiting {waiting(r.created_at)}</span>
              <span className={`text-xs ${r.assigned_to ? "text-slate-200" : "text-red-300"}`} data-testid={`followup-owner-${r.ref}`}>{names[r.assigned_to] ?? "Unassigned"}</span>
              <a href={`tel:${r.mobile}`} className="btn-ghost px-3 py-1.5 text-xs" data-testid={`followup-call-${r.ref}`}><Phone size={13} /> {r.mobile}</a>
              <button onClick={() => markContacted(r.id)} className="btn-primary px-3 py-1.5 text-xs" data-testid={`followup-done-${r.ref}`}><Check size={13} /> Contacted</button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-4 text-sm text-slate-400" data-testid="followups-empty">All caught up — no pending follow-ups.</p>
      )}
    </div>
  );
};
